<template>
  <div
    class="switch-bar"
    :class="{
      'disabled': disabled
    }"
  >
    <button
      class="switch-option-button"
      :class="{
        'active': (option[keyValue] === value),
        'first': (option[keyValue] === firstKey),
        'last': (option[keyValue] === lastKey)
      }"
      v-for="option in options"
      :key="option[keyValue]"
      v-text="option[displayValue]"
      @click="selected(option)"
    />
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'SwitchInput',
    data () {
      return {
      }
    },
    props: {
      value: {
        default: null,
        type: String
      },
      keyValue: {
        default: 'Id',
        type: String
      },
      displayValue: {
        default: 'Name',
        type: String
      },
      options: {
        default: function () {
          return [
            { Id: '0', Name: 'N.v.t.' },
            { Id: '1', Name: 'Yes' },
            { Id: '2', Name: 'No' }
          ]
        },
        type: Array
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      firstKey () {
        let self = this
        return _.first(self.options)[self.keyValue]
      },
      lastKey () {
        let self = this
        return _.last(self.options)[self.keyValue]
      }
    },
    methods: {
      selected (option) {
        let self = this
        if (!self.disabled && (self.value !== option[self.keyValue])) {
          self.$emit('input', option[self.keyValue])
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../uikit';

  .switch-bar {
    box-sizing: border-box;
    display: table;
    height: 25px;

    .switch-option-button {
      background-color: white;
      border: 1px solid $primaryBorderColor;
      border-radius: 0;
      box-sizing: inherit;
      color: #58585b;
      display: table-cell;
      font-size: 13px;
      line-height: 23px;
      margin: 0;
      font-weight: 400;
      font-family: 'Roboto', sans-serif;
      text-align: center;
      text-overflow: ellipsis;
      transition-duration: 0.2s;
      height: 100%;
      width: 75px;
      white-space: nowrap;

      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;

      &.first {
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
      &.last {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }

      &:hover {
        border-color: $primaryBorderColor;
        background-color: $lightGreyBackground;
      }

      &.active {
        color: #ffffff;
        border-color: $primaryBorderColor;
        background-color: $pendingBlue;

        &:hover {
          background-color: $pendingBlue;
        }
      }
    }

    &.disabled {
      .switch-option-button {
        color: $darkGreyBackground;
        background-color: white;
        border-color: $mediumGreyBackground;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/switch/SwitchInput.vue